import React from 'react';
import Skeleton from 'react-loading-skeleton';
import { LazyImage } from "react-lazy-images";


export default class ArticleLazyImage extends React.Component {
  render() {
    console.log(this.props)
    // const {scrollPosition} = this.props;
    return (
      <LazyImage
        src={this.props.image_url}
        alt={this.props.title}
        className={this.props.className}
        debounceDurationMs={900}
        actual={({ imageProps }) => <img {...imageProps} />}
        placeholder={({ ref }) => <div ref={ref} />}
        loading={() => (
          <Skeleton height={this.props.height} width={`100%`} />
        )}
        error={() => (
          <Skeleton height={this.props.height} width={`100%`} />
          
        )}
      />
     
    );
  }
}


                